module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Mrliu"
  }, [_c('div', {
    staticClass: "h-content"
  }, [_c('div', {
    staticClass: "content-left"
  }, [_c('el-tabs', {
    staticStyle: {
      "height": "auto",
      "overflow": "auto",
      "margin-left": "1.7%"
    },
    attrs: {
      "tab-position": "left"
    },
    on: {
      "tab-click": _vm.visitDoctor
    }
  }, _vm._l((_vm.doctor), function(item, index) {
    return _c('el-tab-pane', {
      key: index,
      attrs: {
        "label": item.name
      }
    }, [_c('div', {
      staticClass: "content-right",
      staticStyle: {
        "overflow": "auto"
      }
    }, [_c('router-view', {
      attrs: {
        "dId": _vm.dId
      }
    })], 1)])
  }), 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-461169d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/reservation/Mrliu.vue
// module id = 1015
// module chunks = 2